import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PowerProfile, PowerProfileDTO } from '../models/power-profile.interface';
import { IPowerProfileResource } from './power-profile.resource.interface';
import { Environment, environmentToken } from '@environment';

@Injectable({
  providedIn: 'root'
})
export class PowerProfileResource implements IPowerProfileResource {
  private readonly http = inject(HttpClient);
  private readonly environment = inject<Environment>(environmentToken);
  private readonly baseUrl = `${this.environment.apiUrl + this.environment.apiPath}/power-profile`;

  getProfiles(buildingId: number): Observable<PowerProfile[]> {
    return this.http.get<PowerProfile[]>(`${this.baseUrl}/building/${buildingId}`);
  }

  getNodeAssignments(buildingId: number): Observable<Record<number, number[]>> {
    return this.http.get<Record<number, number[]>>(`${this.baseUrl}/building/${buildingId}/node-assignments`);
  }

  createProfile(dto: PowerProfileDTO, buildingId: number): Observable<PowerProfile> {
    return this.http.post<PowerProfile>(this.baseUrl, { ...dto, buildingId });
  }

  updateProfile(profile: PowerProfile, buildingId: number): Observable<PowerProfile> {
    return this.http.post<PowerProfile>(this.baseUrl, { ...profile, buildingId });
  }

  assignNodes(profileId: number, nodeIds: number[]): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${profileId}/assign-nodes`, nodeIds);
  }
}

